import gql from 'graphql-tag';

export const shareNodeMutation = gql`
  mutation shareNode($id: String!, $targetId: String!) {
    shareNode(id: $id, targetId: $targetId) {
      ok
      error
      node {
        ... on Node {
          id
        }
      }
    }
  }
`;
